import type { FunctionComponent } from "react";
import InfoBanner from "components/shared/InfoBanner";
import PageTitle from "components/shared/PageTitle";
import PaymentJobLink from "components/payment/PaymentInfoBanner/PaymentJobLink";
import PaymentMethod from "components/payment/PaymentInfoBanner/PaymentMethod";
import PaymentOverrideButtons from "components/payment/PaymentInfoBanner/PaymentOverrideButtons";
import PaymentPrice from "components/payment/PaymentInfoBanner/PaymentPrice";
import PaymentStatus from "components/payment/PaymentInfoBanner/PaymentStatus";
import usePaymentInfoBannerProps from "components/payment/PaymentInfoBanner/usePaymentInfoBannerProps";

export interface PaymentInfoBannerProps {}

const PaymentInfoBanner: FunctionComponent<PaymentInfoBannerProps> =
  function () {
    const { title, isLoading } = usePaymentInfoBannerProps();

    return (
      <>
        <PageTitle>{title}</PageTitle>
        <InfoBanner
          title={title}
          isLoading={isLoading}
          nameContent={
            <>
              <div className="flex flex-row flex-wrap">
                <PaymentStatus />
                <PaymentMethod />
                <PaymentPrice />
              </div>
              <div className="flex flex-row flex-wrap mt-6">
                <PaymentJobLink />
                <PaymentOverrideButtons />
              </div>
            </>
          }
        />
      </>
    );
  };

export default PaymentInfoBanner;
